const CREDENTIALS_KEY = 'symplepos_credentials';
const RECENT_STORES_KEY = 'symplepos_recent_stores';

export function saveCredentials({ storeUrl, username, appPassword }) {
  localStorage.setItem(CREDENTIALS_KEY, JSON.stringify({ storeUrl, username, appPassword }));
}

export function loadCredentials() {
  try {
    const raw = localStorage.getItem(CREDENTIALS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.storeUrl && parsed.username && parsed.appPassword) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function clearCredentials() {
  localStorage.removeItem(CREDENTIALS_KEY);
}

export function getRecentStores() {
  try {
    const raw = localStorage.getItem(RECENT_STORES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addRecentStore({ storeUrl, username }) {
  const stores = getRecentStores();
  // Remove existing entry for this URL
  const filtered = stores.filter((s) => s.storeUrl !== storeUrl);
  // Add to front
  filtered.unshift({ storeUrl, username });
  // Keep max 5
  localStorage.setItem(RECENT_STORES_KEY, JSON.stringify(filtered.slice(0, 5)));
}
